import React from 'react';
import Layout from '../components/Layout/Layout';
import Niyamawali from '../components/Niyamawali';

const NiyamawaliPage = () => {
  return (
    <Layout>
      <Niyamawali />
    </Layout>
  );
};

export default NiyamawaliPage;